// MOBILE-11 Phase 1 — the push-permission pre-prompt sheet (build brief §4)
// and the Account → Notifications settings panel (§5, Phase 1 slice only:
// 4 categories × push/email toggles; quiet hours/timezone/"Who handles
// what" are Phase 2, not built yet). Own file rather than folded into
// account.ts since it spans two trigger sites (DocumentViewPage's earned
// moment, AccountPage's settings panel), same reasoning templates.ts/
// photos.ts got their own files when those features arrived.

export const en = {
  "push.prompt.title": "Want a nudge when a payment is due?",
  "push.prompt.body": "SnapDraw can remind you to chase quotes and mark invoices paid. A few a week, never on Sundays.",
  "push.prompt.notNow": "Not now",
  "push.prompt.enable": "Turn on reminders",

  "notifications.title": "Notifications",
  "notifications.help": "Choose what SnapDraw tells you, and where.",
  "notifications.deniedRow": "Notifications are off in your phone's settings — turn them on there to receive push reminders.",
  "notifications.pushColumn": "Push",
  "notifications.emailColumn": "Email",
  "notifications.pushWebOnly": "Push needs the SnapDraw mobile app",
  "notifications.category.doc_followups.title": "Document follow-ups",
  "notifications.category.doc_followups.help": "Nudges to mark quotes and invoices as sent, paid, or lost.",
  "notifications.category.money_aging.title": "Money and aging",
  "notifications.category.money_aging.help": "Weekly pipeline summary and invoices crossing 30/60/90 days.",
  "notifications.category.account_billing.title": "Account and billing",
  "notifications.category.account_billing.help": "Trial reminders, plan changes, receipts.",
  "notifications.category.team_activity.title": "Team activity",
  "notifications.category.team_activity.help": "A daily summary of what your other users did.",
  "notifications.error.generic": "Couldn't save that — try again.",
};

export const es = {
  "push.prompt.title": "¿Quieres un aviso cuando venza un pago?",
  "push.prompt.body": "SnapDraw puede recordarte dar seguimiento a cotizaciones y marcar facturas pagadas. Unos pocos por semana, nunca los domingos.",
  "push.prompt.notNow": "Ahora no",
  "push.prompt.enable": "Activar avisos",

  "notifications.title": "Notificaciones",
  "notifications.help": "Elige qué te avisa SnapDraw, y por dónde.",
  "notifications.deniedRow": "Las notificaciones están desactivadas en la configuración de tu teléfono — actívalas ahí para recibir avisos push.",
  "notifications.pushColumn": "Push",
  "notifications.emailColumn": "Correo",
  "notifications.pushWebOnly": "Push requiere la app móvil de SnapDraw",
  "notifications.category.doc_followups.title": "Seguimiento de documentos",
  "notifications.category.doc_followups.help": "Avisos para marcar cotizaciones y facturas como enviadas, pagadas o perdidas.",
  "notifications.category.money_aging.title": "Dinero y antigüedad",
  "notifications.category.money_aging.help": "Resumen semanal de cartera y facturas que cruzan 30/60/90 días.",
  "notifications.category.account_billing.title": "Cuenta y facturación",
  "notifications.category.account_billing.help": "Recordatorios de prueba, cambios de plan, recibos.",
  "notifications.category.team_activity.title": "Actividad del equipo",
  "notifications.category.team_activity.help": "Un resumen diario de lo que hicieron tus otros usuarios.",
  "notifications.error.generic": "No se pudo guardar — intenta de nuevo.",
};
